import { useState } from 'react';
import { faqs } from '@/mocks/heiliao';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-10 px-4 md:px-8 lg:grid-cols-[0.8fr_1.4fr]">
        <div className="reveal">
          <span className="text-xs font-semibold tracking-[0.3em] text-primary-600">FAQ</span>
          <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-4xl">常见问答</h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            关于分类目录、标签导航、热度口径与内容边界，你可能会关心的问题都整理在这里。
          </p>
          <div className="mt-6 rounded-lg border border-background-300 bg-background-50 p-5">
            <p className="flex items-center gap-2 text-sm font-semibold text-foreground-950">
              <i className="ri-question-answer-line text-primary-600"></i>
              还有别的疑问？
            </p>
            <p className="mt-2 text-xs leading-relaxed text-foreground-600">
              欢迎在订阅页留言，或发送邮件至 contact@44-heiliao.com，我们会在三个工作日内回复。
            </p>
            <a
              href="#subscribe"
              className="mt-4 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-primary-300 px-4 py-2 text-xs font-medium text-primary-700 transition-colors hover:bg-primary-50"
            >
              <i className="ri-mail-line"></i>
              前往联系与订阅
            </a>
          </div>
        </div>

        <div className="reveal divide-y divide-background-300 overflow-hidden rounded-lg border border-background-300 bg-background-50">
          {faqs.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={item.q}>
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    aria-expanded={isOpen}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100 md:px-6"
                  >
                    <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                      {item.q}
                    </span>
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-background-300 text-foreground-600">
                      <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'}></i>
                    </span>
                  </button>
                </h3>
                {isOpen && (
                  <div className="px-5 pb-5 md:px-6">
                    <p className="border-l-2 border-primary-300 pl-4 text-sm leading-7 text-foreground-700">
                      {item.a}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}